import PreviewPay from "../Previews/Deal/PreviewPay/PreviewPay";
import Destination3 from "../Previews/Destination/3/Preview";
import OnboardPromtion4 from "../Previews/Destination/5/Preview";
import OnboardPreview from "../Previews/OnboardPreview/Preview";
import ShipBannerPreview from "../Previews/Ship/Banner/Preview";
import ShipDealPreview from "../Previews/Ship/DealCard/Preview";

export const OnboradingPromotion = {
  form: [
    {
      title: "Page Name",
      key: "page_name",
      className: "col-lg-12",
      type: "input",
    },
    {
      title: "Meta Description",
      key: "meta_description",
      className: "col-lg-12",
      type: "input",
    },
  ],
  component: [
    {
      type: 1,
      fields: [
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },

        {
          title: "Page Image",
          key: "image",
          className: "col-lg-12",
          placeholder: "Upload Page Image",
          type: "file",
          withAlt: true,
          required: false,
        },
      ],
      preview: (activetab, cardData) => (
        <ShipBannerPreview activetab={activetab} cardData={cardData} />
      ),
    },
    {
      type: 1,
      fields: [
        {
          title: "Page Image",
          key: "image",
          className: "col-lg-12",
          placeholder: "Upload Page Image",
          type: "file",
          withAlt: true,
          required: false,
        },

        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },

        {
          title: "English Description",
          key: "description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Simplified Chinese Description",
          key: "simplified_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Traditional Chinese Description",
          key: "traditional_chinese_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Bahasa Description",
          key: "bahasa_description",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
      ],
      preview: (activetab, cardData) => (
        <ShipDealPreview activetab={activetab} cardData={cardData} />
      ),
    },
    {
      type: 3,
      fields: [
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "table",
          className: "col-lg-12",
          type: "table",
          required: false,
        },
      ],
      level1: [
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "html",
          required: false,
        },

        {
          title: "English note",
          key: "note",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Simplified Chinese note",
          key: "simplified_chinese_note",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Traditional Chinese note",
          key: "traditional_chinese_note",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Bahasa note",
          key: "bahasa_note",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Package Title",
          key: "treat_package_title",
          className: "col-lg-4",
          type: "input",
        },
        {
          title: "Package Title",
          key: "deluxe_package_title",
          className: "col-lg-4",
          type: "input",
        },
        {
          title: "Package Title",
          key: "elite_package_title",
          className: "col-lg-4",
          type: "input",
        },

        {
          title: "Simplified chinese Package Title",
          key: "treat_package_title_sc",
          className: "col-lg-4",
          type: "input",
        },
        {
          title: "Simplified chinese Package Title",
          key: "deluxe_package_title_sc",
          className: "col-lg-4",
          type: "input",
        },
        {
          title: "Simplified chinese Package Title",
          key: "elite_package_title_sc",
          className: "col-lg-4",
          type: "input",
        },

        {
          title: "Traditional Chinese Package Title",
          key: "treat_package_title_tc",
          className: "col-lg-4",
          type: "input",
        },
        {
          title: "Traditional Chinese Package Title",
          key: "deluxe_package_title_tc",
          className: "col-lg-4",
          type: "input",
        },
        {
          title: "Traditional Chinese Package Title",
          key: "elite_package_title_tc",
          className: "col-lg-4",
          type: "input",
        },

        {
          title: "Bahasa Package Title",
          key: "treat_package_title_bahasa",
          className: "col-lg-4",
          type: "input",
        },
        {
          title: "Bahasa Package Title",
          key: "deluxe_package_title_bahasa",
          className: "col-lg-4",
          type: "input",
        },
        {
          title: "Bahasa Package Title",
          key: "elite_package_title_bahasa",
          className: "col-lg-4",
          type: "input",
        },

        {
          title: "Package Price",
          key: "treat_package_price",
          className: "col-lg-4",
          type: "input",
        },
        {
          title: "Package Price",
          key: "deluxe_package_price",
          className: "col-lg-4",
          type: "input",
        },
        {
          title: "Package Price",
          key: "elite_package_price",
          className: "col-lg-4",
          type: "input",
        },
        {
          title: "Simplified chinese Package Price",
          key: "treat_package_price_sc",
          className: "col-lg-4",
          type: "input",
        },
        {
          title: "Simplified chinese Package Price",
          key: "deluxe_package_price_sc",
          className: "col-lg-4",
          type: "input",
        },
        {
          title: "Simplified chinese Package Price",
          key: "elite_package_price_sc",
          className: "col-lg-4",
          type: "input",
        },
        {
          title: "Traditional Chinese Package Price",
          key: "treat_package_price_tc",
          className: "col-lg-4",
          type: "input",
        },
        {
          title: "Traditional Chinese Package Price",
          key: "deluxe_package_price_tc",
          className: "col-lg-4",
          type: "input",
        },
        {
          title: "Traditional Chinese Package Price",
          key: "elite_package_price_tc",
          className: "col-lg-4",
          type: "input",
        },
        {
          title: "Bahasa Package Price",
          key: "treat_package_price_bahasa",
          className: "col-lg-4",
          type: "input",
        },
        {
          title: "Bahasa Package Price",
          key: "deluxe_package_price_bahasa",
          className: "col-lg-4",
          type: "input",
        },
        {
          title: "Bahasa Package Price",
          key: "elite_package_price_bahasa",
          className: "col-lg-4",
          type: "input",
        },
        {
          title: "Ship",
          key: "ship",
          className: "col-lg-4",
          type: "ship",
          required: false,
        },
      ],
      level2: [
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },

        {
          title: "Package",
          key: "treat_package",
          className: "col-lg-4",
          type: "select",
          option: [
            {
              id: "yes",
              name: "Yes",
            },
            { id: "no", name: "No" },
          ],
        },
        {
          title: "Package",
          key: "deluxe_package",
          className: "col-lg-4",
          type: "select",
          option: [
            {
              id: "yes",
              name: "Yes",
            },
            { id: "no", name: "No" },
          ],
        },
        {
          title: "Package",
          key: "elite_package",
          className: "col-lg-4",
          type: "select",
          option: [
            {
              id: "yes",
              name: "Yes",
            },
            { id: "no", name: "No" },
          ],
        },
      ],
      preview: (activetab, cardData) => (
        <OnboardPreview activetab={activetab} cardData={cardData} />
      ),
    },
    {
      type: 3,
      fields: [],
      level1: [
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
        },

        {
          title: "Ship",
          key: "ship",
          className: "col-lg-4",
          type: "ship",
          required: false,
        },
      ],
      level2: [
        {
          title: "Popup Image",
          key: "image2",
          className: "col-lg-6",
          placeholder: "Upload Popup Image",
          type: "file",
          withAlt: true,
          required: false,
        },
        {
          title: "Card Image",
          key: "image",
          className: "col-lg-6",
          placeholder: "Upload Card Image",
          type: "file",
          withAlt: true,
          required: false,
        },
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
        },

        {
          title: "English Price",
          key: "sub_title",
          className: "col-lg-3",
          type: "html",
        },
        {
          title: "Simplified Chinese Price",
          key: "simplified_chinese_sub_title",
          className: "col-lg-3",
          type: "html",
        },
        {
          title: "Traditional Chinese Price",
          key: "traditional_chinese_sub_title",
          className: "col-lg-3",
          type: "html",
        },
        {
          title: "Bahasa Price",
          key: "bahasa_sub_title",
          className: "col-lg-3",
          type: "html",
        },

        {
          title: "English Theme",
          key: "type",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Simplified Chinese Theme",
          key: "simplified_chinese_type",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Traditional Chinese Theme",
          key: "traditional_chinese_type",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Bahasa Theme",
          key: "bahasa_type",
          className: "col-lg-3",
          type: "input",
        },

        {
          title: "English Description",
          key: "description",
          className: "col-lg-3",
          type: "html",
        },
        {
          title: "Simplified Chinese Description",
          key: "simplified_chinese_description",
          className: "col-lg-3",
          type: "html",
        },
        {
          title: "Traditional Chinese Description",
          key: "traditional_chinese_description",
          className: "col-lg-3",
          type: "html",
        },
        {
          title: "Bahasa Description",
          key: "bahasa_description",
          className: "col-lg-3",
          type: "html",
        },

        {
          title: "English Filter Text",
          key: "type",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Simplified Chinese Filter Text",
          key: "simplified_chinese_type",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Traditional Chinese Filter Text",
          key: "traditional_chinese_type",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Bahasa Filter Text",
          key: "bahasa_type",
          className: "col-lg-3",
          type: "input",
        },

        {
          title: "English tag",
          key: "tag",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Simplified Chinese tag",
          key: "simplified_chinese_tag",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Traditional Chinese tag",
          key: "traditional_chinese_tag",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Bahasa tag",
          key: "bahasa_tag",
          className: "col-lg-3",
          type: "input",
        },
        {
          title: "Date",
          key: "date",
          className: "col-lg-3",
          lang:"EN",
          type: "date-lang",

        },
        {
          title: "Simplified Chinese Date",
          key: "simplified_chinese_date",
          className: "col-lg-3",
          lang:"SC",
          type: "date-lang",

        },
        {
          title: "Traditional Chinese Date",
          key: "traditional_chinese_date",
          className: "col-lg-3",
          lang:"TC",
          type: "date-lang",

        },
        {
          title: "Bahasa Date",
          key: "bahasa_date",
          className: "col-lg-3",
          lang:"Bahasa",
          type: "date-lang",
        },
        {
          title: "Show Popup",
          key: "popup",
          className: "col-lg-4",
          type: "select",
          option: [
            {
              id: "show",
              name: "Show",
            },
            {
              id: "hide",
              name: "Hide",
            },
          ],
        },
      ],
      preview: (activetab, cardData) => (
        <OnboardPromtion4 activetab={activetab} cardData={cardData} />
      ),
    },
    {
      type: 3,
      fields: [],

      level1: [
        {
          title: "English Title",
          key: "title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Simplified Chinese Title",
          key: "simplified_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Traditional Chinese Title",
          key: "traditional_chinese_title",
          className: "col-lg-3",
          type: "input",
          required: false,
        },
        {
          title: "Bahasa Title",
          key: "bahasa_title",
          className: "col-lg-3",
          type: "input",
        },

        {
          title: "Poster Image",
          key: "image",
          className: "col-lg-12",
          placeholder: "Upload Poster Image",
          type: "file",
          withAlt: true,
          required: false,
        },
        {
          title: "English Note",
          key: "note",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Simplified Chinese Note",
          key: "simplified_chinese_note",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Traditional Chinese Note",
          key: "traditional_chinese_note",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Bahasa Note",
          key: "bahasa_note",
          className: "col-lg-3",
          type: "html",
        },

        {
          title: "Ship",
          key: "ship",
          className: "col-lg-4",
          type: "ship",
          required: false,
        },
      ],
      level2: [
        {
          title: "Price",
          key: "price",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Simplified Chinese  Price",
          key: "simplified_chinese_price",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Traditional Chinese  Price",
          key: "traditional_chinese_price",
          className: "col-lg-3",
          type: "html",
          required: false,
        },
        {
          title: "Bahasa Price",
          key: "bahasa_price",
          className: "col-lg-3",
          type: "html",
        },
      ],
      preview: (activetab, cardData) => (
        <PreviewPay activetab={activetab} cardData={cardData} />
      ),
    },
  ],
};
